import {
    Button,
    Col,
    DatePicker,
    Form,
    Row,
    Typography,
    Select
} from "antd";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addLinkCompany, loadAllCompanies } from "../../redux/rtk/features/linkUser/linkUserSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import LinkUserTblData from "./LinkUserTblData";

const { Option } = Select;

const LinkCompany = ({ drawer }) => {
    const [loader, setLoader] = useState(false);
    const userId = getUserFromToken();

    const companies = useSelector((state) => state?.linkUser?.linkCompany || []);
    const dispatch = useDispatch();
    const { Title } = Typography;
    const [form] = Form.useForm();

    useEffect(() => {
        dispatch(loadAllCompanies());
    }, [dispatch]);

    const onFinish = async (values) => {
        if (values.joinDate) {
            values.joinDate = moment(values.joinDate).format("YYYY-MM-DD");
        }
        const selectedCompany = companies.find(company => company.company_name === values.company_name);
        setLoader(true);
        const resp = await dispatch(addLinkCompany({ 
            id: selectedCompany?.client_Id, // Save client_Id as companyId
            userId: userId,
            joinDate: values.joinDate
        }));
        if (resp.payload?.message === "success") {
            setLoader(false);
            form.resetFields();
        } else {
            setLoader(false);
        }
    };

    const onFinishFailed = () => {
        toast.warning("Failed at updating Company information");
        setLoader(false);
    };

    return (
        <Fragment>
            <Row className='mr-top' justify={drawer ? "center" : "space-between"}>
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={drawer ? 22 : 12}
                    xl={drawer ? 22 : 12}
                    className='column-design border rounded card-custom'>
                    <Title level={4} className='m-2 mt-5 mb-5 text-center'>
                        Company Information
                    </Title>

                    <Form
                        form={form}
                        style={{ marginBottom: "40px" }}
                        name='basic'
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 12 }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete='off'>
                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label='Company Name'
                            name='company_name'
                            rules={[
                                {
                                    required: true,
                                    message: "Please select a company name!",
                                },
                            ]}>
                            <Select placeholder='Select Company Name'>
                                {companies.map(company => (
                                    <Option key={company.id} value={company.company_name}>
                                        {company.company_name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label='Join Date'
                            name='joinDate'
                            rules={[
                                {
                                    required: true,
                                    message: "Please select join date!",
                                },
                            ]}>
                            <DatePicker
                                format="DD-MM-YYYY"
                                style={{ width: "100%" }}
                            />
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            wrapperCol={{
                                offset: 6,
                                span: 12,
                            }}>
                            <Button
                                onClick={() => setLoader(true)}
                                type='primary'
                                size='large'
                                htmlType='submit'
                                block
                                loading={loader}>
                                Update
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
            <Row>
                <LinkUserTblData />
            </Row>
        </Fragment>
    );
};

export default LinkCompany;